/**
 * @fileoverview Configuration for the billing feature.
 * Note: PostBrix is an email builder, not an email sending platform.
 * Plan features reflect builder capabilities: projects, exports, AI, and seats.
 */
export const PRICING_PLANS = [
  {
    "id": "1581be61-2744-477e-9f29-3e98cf2c2bfc",
    "name": "Free",
    "slug": "free",
    "description": "Perfect for trying the editor and side projects.",
    "type": "FREE",
    "trialDays": 0,
    "isPublic": true,
    "sortOrder": 0,
    "autoSync": false,
    "popular": false,
    "cta": "Start for Free",
    "features": [
      {
        "key": "maxProjects",
        "label": "Max Projects",
        "value": 3,
        "included": true
      },
      {
        "key": "maxWorkspaces",
        "label": "Max Workspaces",
        "value": 1,
        "included": true
      },
      {
        "key": "storageLimitMB",
        "label": "Storage Limit (MB)",
        "value": 50,
        "included": true
      },
      {
        "key": "dailyTestEmails",
        "label": "Daily Test Emails",
        "value": 3,
        "included": true
      },
      {
        "key": "monthlyExports",
        "label": "Monthly Exports",
        "value": 5,
        "included": true
      },
      {
        "key": "dailyDownloads",
        "label": "Daily Downloads",
        "value": 5,
        "included": true
      },
      {
        "key": "aiCredits",
        "label": "AI Credits",
        "value": 10,
        "included": true
      },
      {
        "key": "versionHistoryDays",
        "label": "Version History Days",
        "value": 1,
        "included": true
      },
      {
        "key": "maxVersions",
        "label": "Max Versions",
        "value": 3,
        "included": true
      },
      {
        "key": "monthlyApiLimit",
        "label": "Monthly API Limit",
        "value": 0,
        "included": false
      },
      {
        "key": "rateLimitPerMinute",
        "label": "Rate Limit Per Minute",
        "value": 0,
        "included": false
      },
      {
        "key": "autoSave",
        "label": "Auto Save",
        "value": false,
        "included": false
      },
      {
        "key": "comparison",
        "label": "Comparison",
        "value": false,
        "included": false
      },
      {
        "key": "thumbnails",
        "label": "Thumbnails",
        "value": false,
        "included": false
      },
      {
        "key": "publicSharing",
        "label": "Public Sharing",
        "value": false,
        "included": false
      },
      {
        "key": "imageExport",
        "label": "Image Export",
        "value": false,
        "included": false
      },
      {
        "key": "mjmlExport",
        "label": "MJML Export",
        "value": false,
        "included": false
      },
      {
        "key": "teamSupport",
        "label": "Team Support",
        "value": false,
        "included": false
      },
      {
        "key": "removeBranding",
        "label": "Remove Branding",
        "value": false,
        "included": false
      },
      {
        "key": "byok",
        "label": "AI Keys & Model Providers (BYOK)",
        "value": false,
        "included": false
      },
      {
        "key": "apiAccess",
        "label": "Developer API Access & Keys",
        "value": false,
        "included": false
      }
    ],
    "limits": [
      {
        "metric": "PROJECTS",
        "limit": 3
      },
      {
        "metric": "WORKSPACES",
        "limit": 1
      },
      {
        "metric": "STORAGE_MB",
        "limit": 50
      },
      {
        "metric": "EMAIL_SENDS",
        "limit": 3
      },
      {
        "metric": "MONTHLY_EXPORTS",
        "limit": 5
      },
      {
        "metric": "AI_GENERATIONS",
        "limit": 2
      },
      {
        "metric": "MONTHLY_AI_GENERATIONS",
        "limit": null
      },
      {
        "metric": "LIFETIME_AI_GENERATIONS",
        "limit": 10
      },
      {
        "metric": "API_CALLS",
        "limit": 0
      },
      {
        "metric": "MONTHLY_SPAM_CHECKS",
        "limit": 5
      }
    ],
    "prices": [
      {
        "id": "3d8e3d74-e421-4d99-ac25-1d26b0395138",
        "provider": "PADDLE",
        "interval": "MONTHLY",
        "currency": "USD",
        "amount": 0,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": null,
        "providerProductId": "pro_01m034m278mxw8rwkhekrjneks",
        "providerVariantId": "pri_01m034m2s9jyfkgte2s861qnxg"
      },
      {
        "id": "a9ee1b8b-8033-404a-87d9-8b1c7fdd2eb3",
        "provider": "PADDLE",
        "interval": "YEARLY",
        "currency": "USD",
        "amount": 0,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": null,
        "providerProductId": "pro_01m034m47btcg2vag14rr9c14p",
        "providerVariantId": "pri_01m034m567x7wvg5p97q1w8mbq"
      },
      {
        "id": "d30e9acb-28fb-4655-9f16-41b7ba14be77",
        "provider": "RAZORPAY",
        "interval": "MONTHLY",
        "currency": "INR",
        "amount": 0,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": null,
        "providerProductId": null,
        "providerVariantId": null
      },
      {
        "id": "b150169e-bbc2-4ae1-90c9-1146b86eaecb",
        "provider": "RAZORPAY",
        "interval": "YEARLY",
        "currency": "INR",
        "amount": 0,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": null,
        "providerProductId": null,
        "providerVariantId": null
      }
    ],
    "syncStatus": [
      {
        "priceId": "3d8e3d74-e421-4d99-ac25-1d26b0395138",
        "provider": "PADDLE",
        "interval": "MONTHLY",
        "currency": "USD",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": "pri_01m034m2s9jyfkgte2s861qnxg",
          "productId": "pro_01m034m278mxw8rwkhekrjneks"
        }
      },
      {
        "priceId": "a9ee1b8b-8033-404a-87d9-8b1c7fdd2eb3",
        "provider": "PADDLE",
        "interval": "YEARLY",
        "currency": "USD",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": "pri_01m034m567x7wvg5p97q1w8mbq",
          "productId": "pro_01m034m47btcg2vag14rr9c14p"
        }
      },
      {
        "priceId": "d30e9acb-28fb-4655-9f16-41b7ba14be77",
        "provider": "RAZORPAY",
        "interval": "MONTHLY",
        "currency": "INR",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": null,
          "productId": null
        }
      },
      {
        "priceId": "b150169e-bbc2-4ae1-90c9-1146b86eaecb",
        "provider": "RAZORPAY",
        "interval": "YEARLY",
        "currency": "INR",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": null,
          "productId": null
        }
      }
    ]
  },
  {
    "id": "7daaed2c-0f60-4351-8c59-d940dfdd4b91",
    "name": "Starter",
    "slug": "starter",
    "description": "For solo creators shipping professional templates.",
    "type": "PAID",
    "trialDays": 7,
    "isPublic": true,
    "sortOrder": 1,
    "autoSync": true,
    "popular": false,
    "cta": "Choose Starter",
    "features": [
      {
        "key": "includes_free",
        "label": "Everything in Free, plus:",
        "value": true,
        "included": true
      },
      {
        "key": "maxProjects",
        "label": "Max Projects",
        "value": 15,
        "included": true
      },
      {
        "key": "maxWorkspaces",
        "label": "Max Workspaces",
        "value": 5,
        "included": true
      },
      {
        "key": "storageLimitMB",
        "label": "Storage Limit (MB)",
        "value": 200,
        "included": true
      },
      {
        "key": "dailyTestEmails",
        "label": "Daily Test Emails",
        "value": 10,
        "included": true
      },
      {
        "key": "monthlyExports",
        "label": "Monthly Exports",
        "value": true,
        "included": true
      },
      {
        "key": "dailyDownloads",
        "label": "Daily Downloads",
        "value": true,
        "included": true
      },
      {
        "key": "aiCredits",
        "label": "AI Credits",
        "value": 100,
        "included": true
      },
      {
        "key": "versionHistoryDays",
        "label": "Version History Days",
        "value": 7,
        "included": true
      },
      {
        "key": "maxVersions",
        "label": "Max Versions",
        "value": 10,
        "included": true
      },
      {
        "key": "monthlyApiLimit",
        "label": "Monthly API Limit",
        "value": 0,
        "included": false
      },
      {
        "key": "rateLimitPerMinute",
        "label": "Rate Limit Per Minute",
        "value": 0,
        "included": false
      },
      {
        "key": "autoSave",
        "label": "Auto Save",
        "value": true,
        "included": true
      },
      {
        "key": "comparison",
        "label": "Comparison",
        "value": true,
        "included": true
      },
      {
        "key": "thumbnails",
        "label": "Thumbnails",
        "value": true,
        "included": true
      },
      {
        "key": "publicSharing",
        "label": "Public Sharing",
        "value": true,
        "included": true
      },
      {
        "key": "imageExport",
        "label": "Image Export",
        "value": false,
        "included": false
      },
      {
        "key": "mjmlExport",
        "label": "MJML Export",
        "value": true,
        "included": true
      },
      {
        "key": "teamSupport",
        "label": "Team Support",
        "value": false,
        "included": false
      },
      {
        "key": "removeBranding",
        "label": "Remove Branding",
        "value": true,
        "included": true
      },
      {
        "key": "byok",
        "label": "AI Keys & Model Providers (BYOK)",
        "value": false,
        "included": false
      },
      {
        "key": "apiAccess",
        "label": "Developer API Access & Keys",
        "value": false,
        "included": false
      }
    ],
    "limits": [
      {
        "metric": "PROJECTS",
        "limit": 15
      },
      {
        "metric": "WORKSPACES",
        "limit": 5
      },
      {
        "metric": "STORAGE_MB",
        "limit": 200
      },
      {
        "metric": "EMAIL_SENDS",
        "limit": 10
      },
      {
        "metric": "MONTHLY_EXPORTS",
        "limit": null
      },
      {
        "metric": "AI_GENERATIONS",
        "limit": 10
      },
      {
        "metric": "MONTHLY_AI_GENERATIONS",
        "limit": 100
      },
      {
        "metric": "LIFETIME_AI_GENERATIONS",
        "limit": null
      },
      {
        "metric": "API_CALLS",
        "limit": 0
      },
      {
        "metric": "MONTHLY_SPAM_CHECKS",
        "limit": 50
      }
    ],
    "prices": [
      {
        "id": "56c8fec6-c177-4b0c-ac5f-2673f3a6a5a2",
        "provider": "RAZORPAY",
        "interval": "MONTHLY",
        "currency": "INR",
        "amount": 59900,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": "plan_Syq1Yz7bstiQpV",
        "providerProductId": null,
        "providerVariantId": null
      },
      {
        "id": "6061df10-ff36-4bda-90fe-b09537bccbec",
        "provider": "RAZORPAY",
        "interval": "YEARLY",
        "currency": "INR",
        "amount": 599000,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": "plan_Syq1ZN6Hx765dL",
        "providerProductId": null,
        "providerVariantId": null
      },
      {
        "id": "872e45c5-17e0-4b84-8bd0-d16c286e5175",
        "provider": "PADDLE",
        "interval": "MONTHLY",
        "currency": "USD",
        "amount": 900,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": null,
        "providerProductId": "pro_01m035cz8bhbgh7k7zckpt9x1p",
        "providerVariantId": "pri_01m035d01maexdtfttrgtw618c"
      },
      {
        "id": "88c7db36-dd66-4803-b461-91cbb6871780",
        "provider": "PADDLE",
        "interval": "YEARLY",
        "currency": "USD",
        "amount": 9000,
        "seatAmount": null,
        "includedSeats": 1,
        "providerPlanId": null,
        "providerProductId": "pro_01m035d0xnxew31ppe6se2qzb2",
        "providerVariantId": "pri_01m035d1c4x9az7kj8421q4rb3"
      }
    ],
    "syncStatus": [
      {
        "priceId": "56c8fec6-c177-4b0c-ac5f-2673f3a6a5a2",
        "provider": "RAZORPAY",
        "interval": "MONTHLY",
        "currency": "INR",
        "synced": true,
        "providerIds": {
          "planId": "plan_Syq1Yz7bstiQpV",
          "variantId": null,
          "productId": null
        }
      },
      {
        "priceId": "6061df10-ff36-4bda-90fe-b09537bccbec",
        "provider": "RAZORPAY",
        "interval": "YEARLY",
        "currency": "INR",
        "synced": true,
        "providerIds": {
          "planId": "plan_Syq1ZN6Hx765dL",
          "variantId": null,
          "productId": null
        }
      },
      {
        "priceId": "872e45c5-17e0-4b84-8bd0-d16c286e5175",
        "provider": "PADDLE",
        "interval": "MONTHLY",
        "currency": "USD",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": "pri_01m035d01maexdtfttrgtw618c",
          "productId": "pro_01m035cz8bhbgh7k7zckpt9x1p"
        }
      },
      {
        "priceId": "88c7db36-dd66-4803-b461-91cbb6871780",
        "provider": "PADDLE",
        "interval": "YEARLY",
        "currency": "USD",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": "pri_01m035d1c4x9az7kj8421q4rb3",
          "productId": "pro_01m035d0xnxew31ppe6se2qzb2"
        }
      }
    ]
  },
  {
    "id": "520e15a3-dc22-4be4-8cc3-c26d3e093ec0",
    "name": "Pro",
    "slug": "pro",
    "description": "For growing teams that need collaboration and scale.",
    "type": "PAID",
    "trialDays": 14,
    "isPublic": true,
    "sortOrder": 2,
    "autoSync": true,
    "popular": true,
    "cta": "Get Pro Access",
    "features": [
      {
        "key": "includes_starter",
        "label": "Everything in Starter, plus:",
        "value": true,
        "included": true
      },
      {
        "key": "maxProjects",
        "label": "Max Projects",
        "value": 100,
        "included": true
      },
      {
        "key": "maxWorkspaces",
        "label": "Max Workspaces",
        "value": 10,
        "included": true
      },
      {
        "key": "storageLimitMB",
        "label": "Storage Limit (MB)",
        "value": 2000,
        "included": true
      },
      {
        "key": "dailyTestEmails",
        "label": "Daily Test Emails",
        "value": 50,
        "included": true
      },
      {
        "key": "monthlyExports",
        "label": "Monthly Exports",
        "value": true,
        "included": true
      },
      {
        "key": "dailyDownloads",
        "label": "Daily Downloads",
        "value": true,
        "included": true
      },
      {
        "key": "aiCredits",
        "label": "AI Credits",
        "value": 500,
        "included": true
      },
      {
        "key": "versionHistoryDays",
        "label": "Version History Days",
        "value": 30,
        "included": true
      },
      {
        "key": "maxVersions",
        "label": "Max Versions",
        "value": 50,
        "included": true
      },
      {
        "key": "monthlyApiLimit",
        "label": "Monthly API Limit",
        "value": 50000,
        "included": true
      },
      {
        "key": "rateLimitPerMinute",
        "label": "Rate Limit Per Minute",
        "value": 60,
        "included": true
      },
      {
        "key": "autoSave",
        "label": "Auto Save",
        "value": true,
        "included": true
      },
      {
        "key": "comparison",
        "label": "Comparison",
        "value": true,
        "included": true
      },
      {
        "key": "thumbnails",
        "label": "Thumbnails",
        "value": true,
        "included": true
      },
      {
        "key": "publicSharing",
        "label": "Public Sharing",
        "value": true,
        "included": true
      },
      {
        "key": "imageExport",
        "label": "Image Export",
        "value": true,
        "included": true
      },
      {
        "key": "mjmlExport",
        "label": "MJML Export",
        "value": true,
        "included": true
      },
      {
        "key": "teamSupport",
        "label": "Team Support",
        "value": true,
        "included": true
      },
      {
        "key": "removeBranding",
        "label": "Remove Branding",
        "value": true,
        "included": true
      },
      {
        "key": "byok",
        "label": "AI Keys & Model Providers (BYOK)",
        "value": false,
        "included": false
      },
      {
        "key": "apiAccess",
        "label": "Developer API Access & Keys",
        "value": true,
        "included": true
      }
    ],
    "limits": [
      {
        "metric": "PROJECTS",
        "limit": 100
      },
      {
        "metric": "WORKSPACES",
        "limit": 10
      },
      {
        "metric": "STORAGE_MB",
        "limit": 2000
      },
      {
        "metric": "EMAIL_SENDS",
        "limit": 50
      },
      {
        "metric": "MONTHLY_EXPORTS",
        "limit": null
      },
      {
        "metric": "AI_GENERATIONS",
        "limit": 50
      },
      {
        "metric": "MONTHLY_AI_GENERATIONS",
        "limit": 500
      },
      {
        "metric": "LIFETIME_AI_GENERATIONS",
        "limit": null
      },
      {
        "metric": "API_CALLS",
        "limit": 50000
      },
      {
        "metric": "MONTHLY_SPAM_CHECKS",
        "limit": 250
      }
    ],
    "prices": [
      {
        "id": "43d2e540-186a-4783-8f48-3702c632ee4b",
        "provider": "RAZORPAY",
        "interval": "MONTHLY",
        "currency": "INR",
        "amount": 149900,
        "seatAmount": null,
        "includedSeats": 3,
        "providerPlanId": "plan_Syq1dg2fBDt30v",
        "providerProductId": null,
        "providerVariantId": null
      },
      {
        "id": "521b8075-28fa-479e-9ce0-33d644675a68",
        "provider": "RAZORPAY",
        "interval": "YEARLY",
        "currency": "INR",
        "amount": 1499000,
        "seatAmount": null,
        "includedSeats": 3,
        "providerPlanId": "plan_Syq1e5yfBXPBrS",
        "providerProductId": null,
        "providerVariantId": null
      },
      {
        "id": "d5698f7d-cf45-4f8d-81f8-5a95a2dd4b7b",
        "provider": "PADDLE",
        "interval": "MONTHLY",
        "currency": "USD",
        "amount": 2900,
        "seatAmount": null,
        "includedSeats": 3,
        "providerPlanId": null,
        "providerProductId": "pro_01m035kx9mxkphpa7jxyb2crna",
        "providerVariantId": "pri_01m035ky0p5nefpx79tzr51ajb"
      },
      {
        "id": "8bf9316d-7a66-4136-a9cc-94ecc5333122",
        "provider": "PADDLE",
        "interval": "YEARLY",
        "currency": "USD",
        "amount": 29000,
        "seatAmount": null,
        "includedSeats": 3,
        "providerPlanId": null,
        "providerProductId": "pro_01m035kz43mmd3hbz7n6kemfds",
        "providerVariantId": "pri_01m035kzv3nqxrp6n2v4qhschw"
      }
    ],
    "syncStatus": [
      {
        "priceId": "43d2e540-186a-4783-8f48-3702c632ee4b",
        "provider": "RAZORPAY",
        "interval": "MONTHLY",
        "currency": "INR",
        "synced": true,
        "providerIds": {
          "planId": "plan_Syq1dg2fBDt30v",
          "variantId": null,
          "productId": null
        }
      },
      {
        "priceId": "521b8075-28fa-479e-9ce0-33d644675a68",
        "provider": "RAZORPAY",
        "interval": "YEARLY",
        "currency": "INR",
        "synced": true,
        "providerIds": {
          "planId": "plan_Syq1e5yfBXPBrS",
          "variantId": null,
          "productId": null
        }
      },
      {
        "priceId": "d5698f7d-cf45-4f8d-81f8-5a95a2dd4b7b",
        "provider": "PADDLE",
        "interval": "MONTHLY",
        "currency": "USD",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": "pri_01m035ky0p5nefpx79tzr51ajb",
          "productId": "pro_01m035kx9mxkphpa7jxyb2crna"
        }
      },
      {
        "priceId": "8bf9316d-7a66-4136-a9cc-94ecc5333122",
        "provider": "PADDLE",
        "interval": "YEARLY",
        "currency": "USD",
        "synced": true,
        "providerIds": {
          "planId": null,
          "variantId": "pri_01m035kzv3nqxrp6n2v4qhschw",
          "productId": "pro_01m035kz43mmd3hbz7n6kemfds"
        }
      }
    ]
  },
  {
    "id": "ebf839ba-a434-42fd-8665-98f17ccb3b39",
    "name": "Enterprise",
    "slug": "enterprise",
    "description": "Advanced controls, white labeling, and dedicated support.",
    "type": "ENTERPRISE",
    "trialDays": 0,
    "isPublic": false,
    "sortOrder": 3,
    "autoSync": true,
    "popular": false,
    "cta": "Contact Sales",
    "features": [
      {
        "key": "includes_pro",
        "label": "Everything in Pro, plus:",
        "value": true,
        "included": true
      },
      {
        "key": "maxProjects",
        "label": "Max Projects",
        "value": true,
        "included": true
      },
      {
        "key": "maxWorkspaces",
        "label": "Max Workspaces",
        "value": true,
        "included": true
      },
      {
        "key": "storageLimitMB",
        "label": "Storage Limit (MB)",
        "value": 25000,
        "included": true
      },
      {
        "key": "dailyTestEmails",
        "label": "Daily Test Emails",
        "value": 500,
        "included": true
      },
      {
        "key": "monthlyExports",
        "label": "Monthly Exports",
        "value": true,
        "included": true
      },
      {
        "key": "dailyDownloads",
        "label": "Daily Downloads",
        "value": true,
        "included": true
      },
      {
        "key": "aiCredits",
        "label": "AI Credits",
        "value": 2000,
        "included": true
      },
      {
        "key": "versionHistoryDays",
        "label": "Version History Days",
        "value": true,
        "included": true
      },
      {
        "key": "maxVersions",
        "label": "Max Versions",
        "value": true,
        "included": true
      },
      {
        "key": "monthlyApiLimit",
        "label": "Monthly API Limit",
        "value": 500000,
        "included": true
      },
      {
        "key": "rateLimitPerMinute",
        "label": "Rate Limit Per Minute",
        "value": 300,
        "included": true
      },
      {
        "key": "autoSave",
        "label": "Auto Save",
        "value": true,
        "included": true
      },
      {
        "key": "comparison",
        "label": "Comparison",
        "value": true,
        "included": true
      },
      {
        "key": "thumbnails",
        "label": "Thumbnails",
        "value": true,
        "included": true
      },
      {
        "key": "publicSharing",
        "label": "Public Sharing",
        "value": true,
        "included": true
      },
      {
        "key": "imageExport",
        "label": "Image Export",
        "value": true,
        "included": true
      },
      {
        "key": "mjmlExport",
        "label": "MJML Export",
        "value": true,
        "included": true
      },
      {
        "key": "teamSupport",
        "label": "Team Support",
        "value": true,
        "included": true
      },
      {
        "key": "removeBranding",
        "label": "Remove Branding",
        "value": true,
        "included": true
      },
      {
        "key": "customStorage",
        "label": "Custom Storage (S3/MinIO)",
        "value": true,
        "included": true
      },
      {
        "key": "whiteLabel",
        "label": "White Labeling",
        "value": true,
        "included": true
      },
      {
        "key": "byok",
        "label": "AI Keys & Model Providers (BYOK)",
        "value": true,
        "included": true
      },
      {
        "key": "apiAccess",
        "label": "Developer API Access & Keys",
        "value": true,
        "included": true
      }
    ],
    "limits": [
      {
        "metric": "PROJECTS",
        "limit": null
      },
      {
        "metric": "WORKSPACES",
        "limit": null
      },
      {
        "metric": "STORAGE_MB",
        "limit": 25000
      },
      {
        "metric": "EMAIL_SENDS",
        "limit": 500
      },
      {
        "metric": "MONTHLY_EXPORTS",
        "limit": null
      },
      {
        "metric": "AI_GENERATIONS",
        "limit": 200
      },
      {
        "metric": "MONTHLY_AI_GENERATIONS",
        "limit": 2000
      },
      {
        "metric": "LIFETIME_AI_GENERATIONS",
        "limit": null
      },
      {
        "metric": "API_CALLS",
        "limit": 500000
      },
      {
        "metric": "MONTHLY_SPAM_CHECKS",
        "limit": null
      }
    ],
    "prices": [],
    "syncStatus": []
  }
];
